/**
 * 文件的下载逻辑
 * @author huangshuo
 * time 2019-12-24
 */
import * as Util from 'js/util/util.js'
import { mulDownload } from './multi.js'
import _$ from 'js/api/getdata.js'
import cookie from 'js-cookie'
import { webtool_single_dialog, webtool_multi_dialog } from './webtoolDown'
import { checkFile, checkDownloadLimit, sendLogBuryingPointMethods } from '../../download-service/service-download'

const { bJsonp, getData } = require('js/api/getdata').default
const waterMarkLimit = 50 * 1024 * 1024

/**
 * 外链逻辑文件下载
 * @param context 外链详情信息
 * @param param 要下载的数据[{},{}...]
 * @param isDownFolderLink 是否为文件夹外链下载
 * @param callback 回调函数
 */
const linkDownLoad = function (shareInfo, curFileInfo, param) {
  // 外链文件夹下的下载最大选中上线为100个
  const limit = 100
  if (param.length > limit) {
    window.$toast.simpleShow('批量操作数量不能超过100', 'warn')
    return
  }
  if (param.length === 1 && !param[0].is_dir) {
    singleDownload(shareInfo, curFileInfo, param)
  } else {
    packageDownlaod(shareInfo, curFileInfo, param)
  }
  const dIframe = document.getElementById('download-iframe')
  // 载入完成后触发
  dIframe.onload = function () {
    try {
      const { innerText } = dIframe.contentWindow.document.body
      if (innerText.indexOf('msgcode') != -1) { // 如果有报错
        dIframe.contentWindow.document.body.innerText = ''
        const msg = JSON.parse(innerText).message
        alert(window.frames['download-iframe'].contentWindow.document.body.innerHTML)
        window.$toast.simpleShow(dIframe.contentWindow.document.body, 'warn')
      }
    } catch (e) {
      // nothing
    }
  }
}
/**
 * 单文件下载
 */
async function singleDownload(shareInfo, curFileInfo, param) {
  const downloadLimit = await checkDownloadLimit(param)
  let downloadUrl = ''
  if (downloadLimit.data.remain_download === 0) {
    window.$toast.simpleShow('链接下载次数已用尽', 'warn')
    return false
  }
  if(param[0].bytes > 1024 * 1024 * 1024){
    const webTool = await webToolConfirm()
    if(webTool === 'webTool') {
      webtool_single_dialog('link', param, {})
      return false
    }
    if(webTool === 'cancel') {
      return false
    }
  }
  if (param[0].eodDownloadUrl) {
    const result = await getEodUrl(urlEncode(param[0].eodDownloadUrl)) // eod下载地址
    if (result.data.type === 'success') {
      downloadUrl = result.data.downloadUrl
    } else {
      window.$toast.simpleShow(result.data.message, 'warn')
      return false
    }
  } else if (param[0].watermarkDownloadUrl) {
      if(param[0].bytes > waterMarkLimit){
        window.$confirm.show({
          value: true,
          isShow: true,
          onlyOne: true,
          title: '提示',
          sureBtn: '确定',
          content: '文档超过50M,不支持下载水印',
          sure() {
            $confirm.hide()
          },
        })
        return false
      }
    const {code,index} = param[0].requestParam
    const res = await _$.getData(`/v2/delivery/metadata/${code}`,{
      ...param[0].requestParam,
      '_':Date.parse(new Date()),
      'interface_version': 2020
    })
    downloadUrl = encodeWaterMarkUrl(res.data.watermarkDownloadUrl || res.data.content[index].watermarkDownloadUrl) // 水印下载地址
  } else {
    downloadUrl = urlEncode(param[0].download_url) + `&dup_t=${new Date().getTime()}` // 普通下载地址
  }
  downloadUrl += `&X-LENOVO-SESS-ID=${cookie.get('X-LENOVO-SESS-ID')}&session_id=${cookie.get('X-LENOVO-SESS-ID')}`
  document.getElementById('download-iframe').setAttribute('src', downloadUrl)
  if (shareInfo.isLogin) {
    sendLogBuryingPointMethods({
      category: 4,
      action: 403,
      nsid: param[0].nsid,
      entityStr1: param[0].neid,
    })
  }
}

function urlEncode(url) {
  let param = ''
  let baseUrl = url
  if (url.indexOf('?') > -1) {
    const arr = url.split('?')
    param = arr[1]
    baseUrl = arr[0]
  }
  const index = baseUrl.indexOf('/delivery')
  const encodeUrl = encodeURIComponent(baseUrl.slice(index))
  const frontUrl = baseUrl.substring(index, -index)
  return `${frontUrl + encodeUrl}?${param}`
}

function getKeyValue(url) {
  const result = {}
  const reg = new RegExp('([\?|&])(.+?)=([^&?]*)', 'ig')
  let arr = reg.exec(url)
  while (arr) {
    result[arr[2]] = arr[3]
    arr = reg.exec(url)
  }
  return result
}

function encodeWaterMarkUrl(url) {
  const baseUrl = url.split('?')[0]
  const keyValue = getKeyValue(url)
  const arr = []
  for (let i in keyValue) {
    arr.push(`${i}=${encodeURIComponent(keyValue[i])}`)
  }
  return `${baseUrl}?${arr.join('&')}`
}
/**
 * 打包下载
 */
async function packageDownlaod(shareInfo, curFileInfo, param) {
  const fileMsg = await checkFile(param)
  let files = ''
  let neids = ''
  if (fileMsg.status !== 200) {
    window.$toast.simpleShow(fileMsg.data.message, 'warn')
    return false
  }
  if (fileMsg.data.fileNum > 200) {
    window.$toast.simpleShow('该文件夹下包含的文件数量超过200条，无法下载', 'warn')
    webtool_multi_dialog('link', shareInfo, param, {file_limit_code: 'total_file_num_limit'})
    return false
  }
  if (fileMsg.data.bytes > 5 * 1024 * 1024 * 1024) {
    webtool_multi_dialog('link', shareInfo, param, {file_limit_code: 'total_file_size_limit'})
    return false
  }
  if (!fileMsg.data.isAuthFile) {
    const result = await authConfirm()
    if (!result) {
      return false
    }
  }
  param.forEach((value) => {
    files += `files=${encodeURIComponent(value.path)}&`
  })
  param.forEach((value) => {
    neids += `neids=${value.neid}&`
  })
  neids = neids.substr(0, neids.length - 1)
  let downloadUrl = ''
  if (shareInfo.isSecurity) {
    let result = null
    if (shareInfo.isProtected) {
      result = await getEodUrl(`${curFileInfo.download_url}&${neids}`)
    } else {
      result = await getEodUrl(`${curFileInfo.download_url}?${neids}`)
    }

    if (result.data.type === 'success') {
      downloadUrl = result.data.downloadUrl
      if (shareInfo.isProtected) {
        const msg = JSON.parse(localStorage.getItem(`linkToken${curFileInfo.delivery_code}`))
        downloadUrl = `${result.data.downloadUrl}&token=${msg.token}`
      }
    } else {
      $toast.simpleShow(result.data.message, 'warn')
    }
  } else {
    if (shareInfo.isProtected) {
      downloadUrl = `${curFileInfo.download_url}&${files}`
    } else {
      downloadUrl = `${curFileInfo.download_url}?${files}`
    }
  }
  downloadUrl += `&X-LENOVO-SESS-ID=${cookie.get('X-LENOVO-SESS-ID')}&session_id=${cookie.get('X-LENOVO-SESS-ID')}`
  document.getElementById('download-iframe').setAttribute('src', downloadUrl)
  if (shareInfo.isLogin) {
    if (param.length > 1) {
      const arrTrackPoints = []
      param.forEach((v) => {
        arrTrackPoints.push(JSON.stringify({ neid: v.neid, path: v.path }))
      })
      sendLogBuryingPointMethods({
        type: 'batch',
        category: 4,
        action: 403,
        nsid: param[0].nsid,
        pathType: curFileInfo.path_type,
        entityStr1: arrTrackPoints,
        entityStr2: param[0].path.substring(0, param[0].path.lastIndexOf('/')) === '' ? '/' : param[0].path.substring(0, param[0].path.lastIndexOf('/')),
      })
    } else {
      sendLogBuryingPointMethods({
        category: 4,
        action: 403,
        nsid: param[0].nsid,
        entityStr1: param[0].neid,
      })
    }
  }
}

/**
 * 获取打包下载路径
 */
function getDownloadPath(param) {
  const arr = param[0].path.split('/')
  arr.shift()
  arr.shift()
  if (param.length > 1) {
    arr.pop()
  }
  return arr.join('/')
}

async function webToolConfirm() {
  return new Promise((resolve, reject) => {
    window.$confirm.show({
      value: true,
      isShow: true,
      onlyOne: false,
      title: '提示',
      sureBtn: '通过WebTool下载',
      cancelBtn: '取消',
      extraBtn: '继续下载',
      content: '当前文件过大建议使用Web Tool下载，更稳定，更快速',
      sure() {
        resolve('webTool')
        window.$confirm.hide()
      },
      extra() {
        resolve('single')
        window.$confirm.hide()
      },
      cancel() {
        resolve('cancel')
        window.$confirm.hide()
      },
    })
  })
}

async function authConfirm() {
  return new Promise((resolve, reject) => {
    window.$confirm.show({
      value: true,
      isShow: true,
      onlyOne: false,
      title: '提示',
      sureBtn: '继续下载',
      cancelBtn: '取消',
      content: '部分文件无下载权限，继续下载将会过滤这些文件',
      sure() {
        resolve(true)
        window.$confirm.hide()
      },
      cancel() {
        resolve(false)
        window.$confirm.hide()
      },
    })
  })
}

async function getEodUrl(url) {
  return new Promise((resolve, reject) => {
    getData(url).then((res) => {
      resolve(res)
    }).catch((error) => {
      reject(error.response)
    })
  })
}
/**
 * 下载逻辑的判断
 */
function download(context, param, isDownFolderLink, callback) {
  const dIframe = document.getElementById('download-iframe')
  // 载入完成后触发
  dIframe.onload = function () {
    try {
      const { innerText } = dIframe.contentWindow.document.body
      if (innerText.indexOf('msgcode') != -1) { // 如果有报错
        dIframe.contentWindow.document.body.innerText = ''
        const msg = JSON.parse(innerText).message
        $toast.simpleShow(result.message, 'warn')
      }
    } catch (e) {
      // nothing
    }
  }

  // 单个参数为url地址可直接下载
  if (param.length === 1) {
    document.getElementById('download-iframe').setAttribute('src', param[0].download_url)
    return true
  }
}


// +-------------------------外联单文件,文件夹地址下载部分-------------------------------------

/**
 * 格式化要打包的选中数据
 */
function formatData(data) {
  // 定义返回数据
  const nData = []
  data.forEach((item) => {
    nData.push(item.data)
  })
  // 返回数据
  return nData
}

/**
 * 打包数据验证
 */
function checkMulti(data) {
  data.forEach((item) => {
    if (item.is_dir) { // 文件夹

    } else { // 文件

    }
  })
}

/**
 * 文件夹的下载判断
 */
function checkMultiFileDownload(uri) {
  const probeUrl = `${uri}&from_web=true`
  // 请求数据
  bJsonp({
    // 请求地址
    url: probeUrl,
    // 请求参数，对象
    parames: {},
    // 成功回调
    success(result) {
      if (result.code && result.message) {
        multiFileDownloadConfirm(uri, result)
      } else {
        document.getElementById('download-iframe').setAttribute('src', result.dl_url)
      }
    },
  }, 'callback')
}

/**
 * 下载次数的判断
 */
function check_download_times_is_ok(url, isDownFolderLink, callback) {
  // 回调函数
  function check_packaging_callback(result) {
    const warnType = result.warnType || ''
    if (warnType === 'toast') {
      if (result.message) {
        // 弹窗提示警告信息
        $toast.simpleShow(result.message, 'warn')
      }
    } else if (warnType === 'windows') {
      fileDownloadConfirm(url, result)
    } else if ((result.exceed_limit == true) || (result.exceed_limit == 'true')) {
      if (result.message) {
        $toast.simpleShow(result.message, 'warn')
      } else if (!isDownFolderLink) {
        $toast.simpleShow('文件下载次数已用尽，请联系链接创建者！', 'warn')
      }
    } else if ((result.exceed_limit == false) || (result.exceed_limit == 'false')) {
      if (result.security == 1) {
        check_packaging_is_finished(url, result.dl_url, callback)
      } else if (result.security == 0) {
        if (callback) callback()
        document.getElementById('download-iframe').setAttribute('src', result.dl_url)
      }
      if (result.message) {
        Tips.show(result.message)
      }
    } else {
      console.log(result)
    }
  }

  // 请求数据
  bJsonp({
    // 请求地址
    url: `${url}&from_web=true`,
    // 请求参数，对象
    parames: {},
    // 成功回调
    success: check_packaging_callback,
  }, 'callback')
}

/**
 *检查下载连接是否意境准备妥当eod
 */
function check_packaging_is_finished(uri, download_url, callback) {
  let url_status = ''
  if (uri.match('dl_router') !== null) {
    url_status = uri.replace(/dl_router/, 'eod_status')
  } else if (uri.match('pkg_router') !== null) {
    url_status = uri.replace(/pkg_router/, 'eod_status')
  } else if (uri.match('eod') !== null) {
    url_status = uri.replace(/eod/, 'eod_status')
  } else {
    document.getElementById('download-iframe').setAttribute('src', download_url)
    if (callback) callback()
    return
  }

  /* 状态检测结果处理函数 */
  function check_packaging_callback(result) {
    if (result.state == 200) {
      /* 如果返回码是200，则表明下载链接准备好了 */
      document.getElementById('download-iframe').setAttribute('src', download_url)
      if (callback) callback()
    } else if (result.state == 403) {
      /* 否则弹出提示框 */
      $toast.simpleShow(result.message, 'warn')
    } else {
      // 打印请求返回的异常
      console.log(result.state)
    }
  }
  // 请求数据
  bJsonp({
    // 请求地址
    url: url_status,
    // 请求参数，对象
    parames: {},
    // 成功回调
    success: check_packaging_callback,
  }, 'callback')
}

// 提示信息(文件确认并回调下载)
function fileDownloadConfirm(url, result, callback) {
  $confirm.show({
    value: true,
    isShow: true,
    onlyOne: false,
    title: '提示',
    content: result.message,
    sure() {
      if (callback) { callback() }
      if (result.security == 1) { // 安全外联
        check_packaging_is_finished(url, `${result.dl_url}&confirm=yes`)
      } else if (result.security == 0) { // 普通外联
        document.getElementById('download-iframe').setAttribute('src', `${result.dl_url}&confirm=yes`)
      }
    },
  })
}

// 正常外链文件夹与审批外链文件夹对于病毒文件的下载
function multiFileDownloadConfirm(uri, result) {
  $confirm.show({
    value: true,
    isShow: true,
    onlyOne: false,
    title: '提示',
    content: result.message,
    sure() {
      document.getElementById('download-iframe').setAttribute('src', `${result.dl_url}&confirm=yes`)
    },
  })
}

// 导出函数
export { linkDownLoad }
